/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_Hint_HairInputs */

const en_us2_body_assessment_capture_hint_hair = /** @type {(inputs: Body_Assessment_Capture_Hint_HairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hair tied up, clear of your neck and shoulders.`)
};

const pt_br2_body_assessment_capture_hint_hair = /** @type {(inputs: Body_Assessment_Capture_Hint_HairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cabelo preso, longe do pescoço e dos ombros.`)
};

const es_419_body_assessment_capture_hint_hair = /** @type {(inputs: Body_Assessment_Capture_Hint_HairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cabello recogido, lejos del cuello y los hombros.`)
};

const pt_pt2_body_assessment_capture_hint_hair = /** @type {(inputs: Body_Assessment_Capture_Hint_HairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cabelo apanhado, longe do pescoço e dos ombros.`)
};

const fr_fr2_body_assessment_capture_hint_hair = /** @type {(inputs: Body_Assessment_Capture_Hint_HairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheveux attachés, dégagés du cou et des épaules.`)
};

const de_de2_body_assessment_capture_hint_hair = /** @type {(inputs: Body_Assessment_Capture_Hint_HairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haare zusammengebunden, weg von Hals und Schultern.`)
};

const it_it2_body_assessment_capture_hint_hair = /** @type {(inputs: Body_Assessment_Capture_Hint_HairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capelli legati, lontani da collo e spalle.`)
};

/**
* | output |
* | --- |
* | "Hair tied up, clear of your neck and shoulders." |
*
* @param {Body_Assessment_Capture_Hint_HairInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_hint_hair = /** @type {((inputs?: Body_Assessment_Capture_Hint_HairInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_Hint_HairInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_hint_hair(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_hint_hair(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_hint_hair(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_hint_hair(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_hint_hair(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_hint_hair(inputs)
	return en_us2_body_assessment_capture_hint_hair(inputs)
});
export { body_assessment_capture_hint_hair as "body-assessment.capture_hint_hair" }